import { useSearchParams } from 'react-router-dom';
import { FC } from 'react';
import {
  CheckmarkIcon,
  SwitchWorkspaceBlackIcon,
  SwitchWorkspaceWhiteIcon,
} from '@/assets';
import { WorkspaceFromStore } from '@/types/workspaces';

interface Props {
  workspace: WorkspaceFromStore;
  onSelectWorkspace: (workspaceId: string) => void;
}

export const ModalNavLink: FC<Props> = ({ workspace, onSelectWorkspace }) => {
  const [searchParams] = useSearchParams();
  const isActive = searchParams.get('workspaceId') === workspace.id;
  const isDisabled = workspace.status === 'DELETION_AWAITING';

  const styles = [
    'flex items-center py-2.5 px-5 gap-2.5 !w-full h-10 font-lato style-normal font-semibold text-xs tracking-[2px] uppercase bg-blue rounded-lg transition-bg duration-200',
  ];

  if (isDisabled) {
    styles.push('bg-[#f5f5f5] pointer-events-none cursor-not-allowed');
  } else if (isActive) {
    styles.push('bg-primary-600 text-white');
  } else {
    styles.push('bg-white text-[#212121] hover:bg-primary-100');
  }

  return (
    <li className="w-full">
      <button
        onClick={() => onSelectWorkspace(workspace.id)}
        className={styles.join(' ')}
        // relative="route"
        // to={{ hash: '', search: `?workspaceId=${workspace.id}` }}
      >
        <>
          <img
            src={
              isActive && !isDisabled
                ? SwitchWorkspaceWhiteIcon
                : SwitchWorkspaceBlackIcon
            }
            alt="switch workspace icon"
          />
          <p>
            {workspace.name}
            {isDisabled && ' - AWAITING DELETION'}
          </p>
          <img
            style={{ marginLeft: 'auto' }}
            src={CheckmarkIcon}
            alt="switch workspace icon"
          />
        </>
      </button>
    </li>
  );
};
